<template>
  <table class="table table-sm dropdowns-special" v-if="matrix != undefined">
    <caption class="caption table-caption">{{ matrixName + ' (' + matrixUnits + ')' }}</caption>
    <thead>
      <th class="text-left corner"><span class="cdr">CDR</span><span class="cpr">CPR</span></th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[0]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 0, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[1]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 1, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[2]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 2, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[3]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 3, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[4]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 4, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[5]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 5, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[6]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 6, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
      <th>
        <b-input-group>
          <b-form-input class="calculation-settings-input text-right" v-model="cpr[7]"></b-form-input>
          <template v-slot:append>
            <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
              <template slot="button-content"><i class="fas fa-sort-down"></i></template>
              <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                @click='selectVector(cpr, 7, vectorName)'>{{vectorName}}</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-input-group>
      </th>
    </thead>
    <tbody>
      <tr v-for="index in 9" :key=index>
        <th class="cdrHeaderCell">
          <b-input-group>
            <b-form-input class="calculation-settings-input text-right inputBox" v-model="cdr[index-1]"></b-form-input>
            <template v-slot:append>
              <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" :disabled="vectors.length == 0">
                <template slot="button-content"><i class="fas fa-sort-down"></i></template>
                <b-dropdown-item v-for="vectorName of vectors" :key="vectorName"
                  @click='selectVector(cdr, index - 1, vectorName)'>{{vectorName}}</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-input-group>
        </th>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[0], cdr[index-1])">{{matrix[0][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[1], cdr[index-1])">{{matrix[1][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[2], cdr[index-1])">{{matrix[2][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[3], cdr[index-1])">{{matrix[3][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[4], cdr[index-1])">{{matrix[4][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[5], cdr[index-1])">{{matrix[5][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[6], cdr[index-1])">{{matrix[6][index-1]}}</td>
        <td class="text-right hover" @click="onClick(matrixType || matrixName, cpr[7], cdr[index-1])">{{matrix[7][index-1]}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import CalculationSettingsInput from "./dealInformation/CalculationSettingsInput";

export default {
  props: {
    matrixName: String,
    matrixUnits: String,
    matrixType: String,
    cpr: Array,
    cdr: Array,
    matrix: Array,
    vectors: Array
  },
  methods: {
    onClick(type, cpr, cdr) {
      this.$emit("matrixCellClicked", { type: type.toLowerCase(), cpr: cpr, cdr: cdr });
    },
    selectVector(array, index, val) {
      this.$set(array, index, val)
    }
  },
  components: {
    CalculationSettingsInput
  }
}
</script>

<style lang="scss">
.toggle-class {
  padding-right: 0;
  padding-left: 0.5rem;
  i {
    font-size: 1rem !important;
    transform: translateY(-2px);
  }
}
.cdrHeaderCell {
  min-width: 150px;
  position: relative;
  .input-group {
    flex-flow: row;
  }
  .inputBox {
    width: 92%
  }
  div:not(.input-group):not(.input-group-append):not(.b-dropdown) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    ul {
      left: 18px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.cpr {
  position: absolute;
  top: 0;
  right: 0.3rem;
}
.cdr {
  position: absolute;
  bottom: 0;
  left: 0.3rem;
}
.corner {
  position: relative;
  width: 10%;
  height: 100%;
  background:linear-gradient(to top right,
    white 48%,
    #b3b3b3,
    white 52%);
}
.hover {
  &:hover {
    background-color: rgba(23, 162, 184, 0.3);
    cursor: pointer;
  }
}
</style>
